export default __webpack_public_path__ + "static/media/glrc-course.holistic-nutrition-and-wellness.2090c2de.png";